import useSWR from "swr";
import axiosSingleton from "../api/axios";
import config from "../config";

export function usePlanUrls(planSlug: string, getOverview = false) {
    const endpoint = getOverview ? "plans/planoverview" : "plans/summaryofbenefits";
    const requestUrl = `${config.PUBLIC_SITE_API_BASE_URL}${endpoint}/${planSlug}`;
    const { isLoading, data: planUrl, error } = useSWR(requestUrl, {
        fetcher: async (url: string) => {
            const res = await axiosSingleton.get(url);
            if (res.status !== 200) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.data.url;
        },
        errorRetryCount: 1,
        dedupingInterval: 3600000, // 1 hour deduplication - cache SBC URL for 1 hour
    });
    return { planUrl, isLoading, error };
}